import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from "@angular/router";
import {SplashScreenComponent} from "./splash-screen.component";

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [SplashScreenComponent],
  exports: [SplashScreenComponent]
})
export class SplashScreenModule { }
